import React from 'react';
import { Box, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { toSentenceCase } from '../../utils/casing';

/**
 * Primary pink "Take Me Home" button (white text, pink background) matching the
 * standard call-to-action button. Navigates back to the home page.
 */
const TakeMeHomeButton = ({ sx }) => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        mt: '40px',
        ...sx,
      }}
    >
      <Button
        variant="contained"
        onClick={() => navigate('/')}
        sx={{
          width: '175px',
          height: '48px',
          gap: '12px',
          borderRadius: '20px',
          backgroundColor: '#FF0074',
          textTransform: 'none',
          fontFamily: 'Inter',
          fontWeight: 700,
          color: '#FFFFFF',
          fontSize: '1.25rem',
          lineHeight: '24px',
          letterSpacing: '-0.3px',
          '&:hover': { backgroundColor: '#e6006a' },
        }}
      >
        {toSentenceCase('Take Me Home')}
      </Button>
    </Box>
  );
};

export default TakeMeHomeButton;
